import React from "react";

export default function Contact() {
  return (
    <section id="contact" className="bg-gray-900">
      <div className="container mx-auto px-6 py-20">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-100 mb-4">
              Get in Touch
            </h2>
            <p className="text-gray-500">
              Interested in working together? Send me a message or reach out
              directly.
            </p>
            <a
              href="mailto:danielcoates27@gmail.com"
              className="inline-block mt-4 text-indigo-400 hover:text-indigo-300 font-medium"
            >
              danielcoates27@gmail.com
            </a>
          </div>
          <form
            netlify="true"
            name="contact"
            method="POST"
            action="/"
            className="space-y-6"
          >
            <input type="hidden" name="form-name" value="contact" />
            <div>
              <label
                htmlFor="name"
                className="block text-sm font-medium text-gray-300 mb-1"
              >
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                className="w-full bg-gray-800 rounded-lg border border-gray-700 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-900 text-base outline-none text-gray-200 py-2.5 px-4 leading-8 transition-colors"
              />
            </div>
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-300 mb-1"
              >
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                className="w-full bg-gray-800 rounded-lg border border-gray-700 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-900 text-base outline-none text-gray-200 py-2.5 px-4 leading-8 transition-colors"
              />
            </div>
            <div>
              <label
                htmlFor="message"
                className="block text-sm font-medium text-gray-300 mb-1"
              >
                Message
              </label>
              <textarea
                id="message"
                name="message"
                rows="5"
                className="w-full bg-gray-800 rounded-lg border border-gray-700 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-900 text-base outline-none text-gray-200 py-2.5 px-4 resize-none leading-6 transition-colors"
              />
            </div>
            <button
              type="submit"
              className="w-full bg-indigo-600 text-white py-3 px-6 rounded-lg font-medium hover:bg-indigo-700 transition-colors"
            >
              Send Message
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/components/Contact.js